import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/components/ui/use-toast';
import { useAuth } from '@/contexts/AuthContext';

export function useKeyboardShortcuts() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { signOut } = useAuth();

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      // Ignorar se estiver digitando em um input, textarea ou contentEditable
      if (
        event.target instanceof HTMLInputElement ||
        event.target instanceof HTMLTextAreaElement ||
        (event.target instanceof HTMLElement && event.target.isContentEditable)
      ) {
        return;
      }

      // Atalhos com Ctrl/Cmd + tecla
      if (event.ctrlKey || event.metaKey) {
        switch (event.key.toLowerCase()) {
          case 'k':
            event.preventDefault();
            // Em vez de toast, abre a busca global
            window.dispatchEvent(new CustomEvent('global-search-open'));
            break;
          case 'h':
            event.preventDefault();
            navigate('/');
            break;
          case 'p':
            event.preventDefault();
            // Abrir modal de perfil global
            window.dispatchEvent(new CustomEvent('profile-modal-open'));
            break;
          case 'q':
            event.preventDefault();
            signOut();
            break;
          case '?':
            event.preventDefault();
            // Mostrar atalhos disponíveis
            toast({
              title: 'Atalhos Disponíveis',
              description: (
                <div className="mt-2 space-y-2">
                  <p>Ctrl/Cmd + K: Busca Global</p>
                  <p>Ctrl/Cmd + H: Home</p>
                  <p>Ctrl/Cmd + P: Perfil</p>
                  <p>Ctrl/Cmd + Q: Sair</p>
                  <p>Ctrl/Cmd + ?: Mostrar Atalhos</p>
                </div>
              ),
            });
            break;
        }
      }

      // Atalhos com tecla única
      switch (event.key) {
        case '/':
          event.preventDefault();
          // Em vez de toast, abre a busca global
          window.dispatchEvent(new CustomEvent('global-search-open'));
          break;
        case 'Escape':
          // Fechar modais, dropdowns, etc
          break;
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [navigate, toast, signOut]);
}
